import styled from 'styled-components';

export const ProgressContainer = styled.div`
  margin-top: 0.75rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;

  .hefesto-progress__label {
    display: none;
  }
`;
